import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import carrierAssignmentChangeLogService from "app/data/carrier-assignment-changes/carrierAssignmentChangeLogService";
import { CarrierAssignmentChangeLogFilterModel } from "app/data/carrier-assignment-changes/models";

export const useCarrierAssignmentChangeLog = (
  planId: string | number | undefined | null,
  filter: CarrierAssignmentChangeLogFilterModel = {},
  enabled = true
) => {
  const { dateFrom, dateTo } = filter;

  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.CARRIER_ASSIGNMENT_CHANGE_LOG, planId, dateFrom, dateTo],
    queryFn: async ({ pageParam = 0 }) => {
      return carrierAssignmentChangeLogService.getByPlanId(
        planId as string | number,
        { dateFrom, dateTo },
        pageParam
      );
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.last) return undefined;
      return (lastPage?.pageable?.pageNumber ?? 0) + 1;
    },
    enabled: enabled && planId != null && planId !== "",
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export const useCarrierAssignmentChangeLogSearch = (
  filter: CarrierAssignmentChangeLogFilterModel = {},
  enabled = true
) => {
  const { dateFrom, dateTo, sourceType, search, carrierNumber } = filter;

  return useInfiniteQuery({
    queryKey: [
      QUERY_KEYS.CARRIER_ASSIGNMENT_CHANGE_LOG,
      "search",
      sourceType,
      search,
      carrierNumber,
      dateFrom,
      dateTo,
    ],
    queryFn: async ({ pageParam = 0 }) => {
      return carrierAssignmentChangeLogService.search(
        { dateFrom, dateTo, sourceType, search, carrierNumber },
        pageParam
      );
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.last) return undefined;
      return (lastPage?.pageable?.pageNumber ?? 0) + 1;
    },
    enabled,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
